import { render, staticRenderFns } from "./KeywordManagement.vue?vue&type=template&id=b657336c&scoped=true"
import script from "./KeywordManagement.vue?vue&type=script&lang=js"
export * from "./KeywordManagement.vue?vue&type=script&lang=js"
import style0 from "./KeywordManagement.vue?vue&type=style&index=0&id=b657336c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b657336c",
  null
  
)

export default component.exports